import { render, staticRenderFns } from "./cryptounicorns.vue?vue&type=template&id=07ca79ed&"
import script from "./cryptounicorns.vue?vue&type=script&lang=js&"
export * from "./cryptounicorns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports